import { TablePagination } from "@mui/material";
import { IPagination } from "../../interfaces/pagination/IPagination";
import { Dispatch, SetStateAction } from "react";

interface Props {
    rowCount: number;
    pagination: IPagination
    setController: Dispatch<SetStateAction<IPagination>>;
}

export default function Pagination(props: Props) {
    const { rowCount, pagination, setController } = props;
    
    const handlePageChange = (event: any, newPage: number) => {
        setController({
            ...pagination,
            page: newPage
        });
    };

    const handleChangeRowsPerPage =(event: any) => {
        setController({
            ...pagination,
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        });
    };

    return(
        <TablePagination 
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={rowCount}
            rowsPerPage={pagination.rowsPerPage}
            page={pagination.page}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Linhas por página"
        />
    )
}